import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';
export const StyledFab = styled(Fab)(
  () => `
    position:absolute;
    bottom:-370px;
    right:30px;
  `,
);
